// Source: app/scripts/controllers/page-group.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('PageGroupController', ['$scope', function ($scope) {
  $scope.setBase = function (_scope, base) {
    $scope.entity = base;
  };
  $scope.clearBase = function (_scope) {
    delete $scope.entity;
  };

  $scope.onGroupsInit = function (_scope) {
    _scope.faChange = function (n) {
      if (!n) return;
      _scope.entity.icon = 'fa fa-fw ' + n;
    };
    _scope.renderIcon = function (clean, formated) {
      return "<i class='fa fa-fw " + clean + "'></i> " + formated;
    };
  };

}]);
